// ══════════════════════════════════════════════════════════════
//  COMPANY SETTINGS
// ══════════════════════════════════════════════════════════════
export const COMPANY_SETTINGS = {
  companyName: "GoSnel",
  companyLogo: "https://media.gosnel.com/GoSnelLogoText.png",
  primaryColor: "#0ea5e9",
  countryCode: "971", // UAE country code
  whatsappMsg: "مرحباً، أنا من فريق GoSnel ونودّ التحدث معكم بخصوص الانضمام لمنصتنا 🙂",
};

// ══════════════════════════════════════════════════════════════
//  STATUS METADATA
// ══════════════════════════════════════════════════════════════
export const STATUS_META = {
  new:             { label:"جديد",                    color:"#94a3b8", bg:"#1a2540",  icon:"🆕", order:0 },
  data_review:     { label:"مراجعة البيانات",         color:"#f59e0b", bg:"#3d2000",  icon:"📝", order:1 },
  ready_for_rep:   { label:"مراجعة المدير",           color:"#3b8b6", bg:"#162050",  icon:"🔍", order:2 },
  invoice_pending: { label:"بانتظار الفاتورة",        color:"#a78bfa", bg:"#200d50",  icon:"💰", order:3 },
  in_field:        { label:"في الميدان",              color:"#22d3ee", bg:"#0a3040",  icon:"🚶", order:4 },
  pending_closure: { label:"بانتظار الإغلاق",         color:"#fb923c", bg:"#3a1000",  icon:"⏳", order:5 },
  deal_closed:     { label:"تم الإغلاق",              color:"#34d399", bg:"#052e16",  icon:"🎉", order:6 },
};

// ══════════════════════════════════════════════════════════════
//  ROLE METADATA
// ══════════════════════════════════════════════════════════════
export const ROLE_META = {
  admin:         { label:"مدير النظام",     color:"#f59e0b", icon:"👑" },
  marketer:      { label:"منسّقة صفقات",   color:"#10b981", icon:"📣" },
  data_entry:    { label:"مدخل بيانات",     color:"#0ea5e9", icon:"⌨️" },
  sales_manager: { label:"مدير مبيعات",     color:"#a78bfa", icon:"🎯" },
  accountant:    { label:"محاسب",           color:"#fb923c", icon:"💼" },
  rep:           { label:"مندوب ميداني",    color:"#34d399", icon:"🤝" },
};

// ══════════════════════════════════════════════════════════════
//  ROLE VISIBILITY (which statuses each role can see)
// ══════════════════════════════════════════════════════════════
export const ROLE_VISIBILITY = {
  admin:         null,
  sales_manager: null,
  marketer:      null, // filtered by assignedMarketer
  data_entry:    ["data_review"],
  accountant:    ["invoice_pending"],
  rep:           ["in_field", "pending_closure"],
};

// ══════════════════════════════════════════════════════════════
//  FILE UPLOAD PERMISSIONS PER ROLE
// ══════════════════════════════════════════════════════════════
export const ROLE_UPLOAD_PERMS = {
  marketer:      ["logoUrl", "menu1Url", "menu2Url"],
  data_entry:    [],
  sales_manager: [],
  accountant:    ["invoiceUrl"],
  rep:           ["tradeLicenseUrl", "ownerIdUrl"],
  admin:         ["logoUrl", "menu1Url", "menu2Url", "invoiceUrl", "tradeLicenseUrl", "ownerIdUrl"],
};

// ══════════════════════════════════════════════════════════════
//  CSV COLUMN HINTS
// ══════════════════════════════════════════════════════════════
export const CSV_HINTS = {
  name:["name","restaurant_name","restaurant","اسم المطعم","المطعم"],
  ownerName:["owner","owner_name","صاحب","مالك"],
  phone:["phone","mobile","tel","هاتف","جوال","رقم"],
  area:["district","area","region","location","المنطقة","الحي"],
  mapsUrl:["maps","google_maps","map_url","خريطة","موقع"],
  notes:["notes","remarks","ملاحظات"],
};

// ══════════════════════════════════════════════════════════════
//  GLOBAL STYLES
// ══════════════════════════════════════════════════════════════
export const S = {
  bg:"#060c18", card:"#0c1525", border:"#162035",
  txt:"#f1f5f9", muted:"#94a3b8", input:"#060c18",
  pri:"#0ea5e9", ok:"#10b981", warn:"#f59e0b", err:"#ef4444",
};

// ══════════════════════════════════════════════════════════════
//  UTILITY FUNCTIONS
// ══════════════════════════════════════════════════════════════

// Check if all required files are present
export function allFilesPresent(files) {
  return !!(files.logoUrl && files.menu1Url && files.invoiceUrl && files.tradeLicenseUrl && files.ownerIdUrl);
}

// Format phone number
export function fmtPhone(raw, cc = "971") {
  const d = raw.replace(/\D/g, "");
  if (!d) return "";
  if (d.startsWith("00")) return "+" + d.slice(2);
  if (d.startsWith("0"))  return "+" + cc + d.slice(1);
  return "+" + d;
}

// Detect CSV column mapping
export function detectCol(h) {
  const lh = h.toLowerCase().trim();
  for (const [f, hints] of Object.entries(CSV_HINTS)) {
    if (hints.some(hint => lh.includes(hint.toLowerCase()))) return f;
  }
  return "ignore";
}

// Parse CSV text
export function parseCSV(text) {
  const lines = text.trim().split(/\r?\n/);
  if (lines.length < 2) return { headers:[], rows:[] };
  const headers = lines[0].split(",").map(h => h.trim().replace(/^"|"$/g,""));
  const rows = lines.slice(1).map(line => {
    const vals=[]; let cur="", inQ=false;
    for (const ch of line) {
      if (ch==='"') inQ=!inQ;
      else if (ch===','&&!inQ) { vals.push(cur.trim()); cur=""; }
      else cur+=ch;
    }
    vals.push(cur.trim());
    return headers.reduce((o,h,i) => { o[h]=vals[i]||""; return o; }, {});
  });
  return { headers, rows };
}

// Create file object with defaults
export const mkF = (o={}) => ({ 
  logo_url:"", menu_url_1:"", menu_url_2:"", invoice_url:"", 
  trade_license_url:"", owner_id_url:"", ...o 
});

// Format time ago (for presence tracking)
export function timeAgo(date) {
  if (!date) return 'غير معروف';
  const now = new Date();
  const past = new Date(date);
  const diffMs = now - past;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  
  if (diffMins < 1) return 'الآن';
  if (diffMins < 60) return `منذ ${diffMins} دقيقة`;
  if (diffHours < 24) return `منذ ${diffHours} ساعة`;
  if (diffDays < 7) return `منذ ${diffDays} يوم`;
  return past.toLocaleDateString('ar-AE');
}

// Check if user is online (active within last 5 minutes)
export function isUserOnline(lastActive) {
  if (!lastActive) return false;
  const now = new Date();
  const last = new Date(lastActive);
  return (now - last) < 5 * 60 * 1000; // 5 minutes
}
